import { render, staticRenderFns } from "./IssueReportDevelopmentName.vue?vue&type=template&id=09f21ca1&scoped=true&"
var script = {}
import style0 from "./IssueReportDevelopmentName.vue?vue&type=style&index=0&id=09f21ca1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f21ca1",
  null
  
)

export default component.exports